import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import useSeo from '@/hooks/useSeo';

export default function NotFound() {
  useSeo({
    title: '页面未找到 - 洞洞杂货铺漫画',
    description: '你访问的页面不存在，返回洞洞杂货铺漫画首页继续探索。',
  });

  return (
    <Layout>
      <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-24 text-center">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-background-100 text-5xl font-bold text-primary-500">
          洞
        </span>
        <h1 className="mt-6 text-2xl text-foreground-950 md:text-3xl">这里似乎缺了一个洞</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你要找的页面就像杂货铺里一件走失的商品，暂时找不到了。回到首页，或许能发现新的缘分。
        </p>
        <Link
          to="/"
          className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-sm" aria-hidden="true"></i>
          返回首页
        </Link>
      </div>
    </Layout>
  );
}